<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BulkContractServiceFeeEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :resourceTitle="'Contract Service Fees'|pgettext('BulkContractServiceFeeEditor|ResourceTitle')"
    :resourceKey="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="valid_from"
        :label="'Valid From'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="valid_from_enabled"
              v-model="item.$updates.valid_from"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="valid_from"
          v-model="item.valid_from"
          :disabled="!item.$updates.valid_from"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="valid_to"
        :label="'Valid To'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="valid_to_enabled"
              v-model="item.$updates.valid_to"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="valid_to"
          v-model="item.valid_to"
          :disabled="!item.$updates.valid_to"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="amount"
        :label="'Amount'|pgettext('ContractServiceFee')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="amount_enabled"
              v-model="item.$updates.amount"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          name="amount"
          v-model="item.amount"
          :disabled="!item.$updates.amount"
          mask="number"
          unmask="typed"
          scale="4"
          class="w-auto"
        >
        </ItpFormInput>
        <ItpFormSelect
          name="currency"
          :options="currencies"
          v-model="item.currency"
          :disabled="!item.$updates.amount"
          textField="code"
          valueField="code"
          class="w-auto"
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        name="quantity"
        :label="'Quantity'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="quantity_enabled"
              v-model="item.$updates.quantity"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          type="number"
          name="quantity"
          v-model="item.quantity"
          :disabled="!item.$updates.quantity"
          class="w-auto"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="unit_of_quantity"
        :label="'Unit of quantity'|pgettext('ContractServiceFee')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="unit_of_quantity_enabled"
              v-model="item.$updates.unit_of_quantity"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormInput
          type="number"
          name="unit_of_quantity"
          v-model="item.unit_of_quantity"
          :disabled="!item.$updates.unit_of_quantity"
          class="w-auto"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="inflation_indexed"
        :label="'Inflation indexed'|pgettext('ContractServiceFee')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="inflation_indexed_enabled"
              v-model="item.$updates.inflation_indexed"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormCheckbox
          type="number"
          name="inflation_indexed"
          v-model="item.inflation_indexed"
          :disabled="!item.$updates.inflation_indexed"
          class="w-auto"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="transaction_notes"
        :label="'Transaction notes'|pgettext('ContractServiceFee')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="transaction_notes_enabled"
              v-model="item.$updates.transaction_notes"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <TransactionNotesEditor
          type="number"
          name="transaction_notes"
          v-model="item.transaction_notes"
          :disabled="!item.$updates.transaction_notes"
          class="w-auto"
        >
        </TransactionNotesEditor>
      </ItpFormGroup>
      <hr
        class="my-4"
      >
      </hr>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="notes_enabled"
              v-model="item.$updates.notes"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
          :disabled="!item.$updates.notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BulkContractServiceFeeEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getItemFromInput(...args: any[]) {
    const [inputItems, fields] = args;
    const fieldNames = _.map(fields, 'name');

    let result = {}

    _.each(inputItems, (item, i) => {
      if (i === 0) {
        result = _.pick(item, fieldNames);
      }

      for (const { name, defaultValue } of fields) {
        if (result[name] != item[name]) {
          result[name] = defaultValue;
          continue;
        }

        if (_.isUndefined(result[name])) {
          result[name] = defaultValue;
          continue;
        }

        if (result[name] != null) {
          result[name] = item[name];
        }
      }
    });

    result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {})
    return result;
  }

  getPayload(...args: any[]) {
    const [inputItems, item] = args;

    const updates = _.keys(_.pickBy(item.$updates, _.identity));

    if (!updates.length) {
      return
    }

    const update = _.pick(item, updates)

    return {
      items: _.map(inputItems, item => ({
        id: item.id,
        etag: item.etag,
        value: update
      }))
    };
  }

  @Prop({
    type: Array,
  })
  items!: array;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  editableFields!: any;
  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.getItemFromInput(this.items, this.$data.editableFields)
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  paymentMethods!: any;

  async $$load_paymentMethods() {
    return this.$fn.fetch('list_payment_method')
      .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['editableFields', 'labelAlign', 'formId', 'formName', 'item', 'currencies', 'paymentMethods', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        editableFields: [{
          name: "valid_from",
        }
          ,
        {
          name: "valid_to",
        }
          ,
        {
          name: "amount",
        }
          ,
        {
          name: "currency",
        }
          ,
        {
          name: "unit",
        }
          ,
        {
          name: "quantity",
        }
          ,
        {
          name: "unit_of_quantity",
        }
          ,
        {
          name: "inflation_indexed",
        }
          ,
        {
          name: "transaction_notes",
        }
          ,
        {
          name: "notes",
        }
          ,
        ]
        ,
        labelAlign: "right",
        formId: null,
        formName: "BulkContractServiceFeeEditor",
        item: null,
        currencies: null,
        paymentMethods: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("BulkContractServiceFeeEditor|Title", "Bulk Edit"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8806_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8806, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_8812_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_8812, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_8810_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_8810, alias=save
    return {
      operation: "bulk_update_contract_service_fee",
      data: this.getPayload(this.items, this.item),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8806: actions.CloseModalAction;
    evh_7315092382398562_close_8805: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8808: actions.CloseComponentAction;
    evh_2248226175642056_close_8807: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_8812: actions.CloseModalAction;
    evh_1040167445267876_success_8811: actions.EventHandlerImpl;
    act_1040167445267876_request_8810: actions.RequestAction;
    evh_1040167445267876_submit_8809: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_8814: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_8813: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8806 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8806_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8805 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8806,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8805],
      }
    );
    const act_2248226175642056_closeComponent_8808 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8807 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8808,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8807],
      }
    );
    const act_1040167445267876_closeModal_8812 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_8812_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8811 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_8812,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_8810 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_8810_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_8811],
      }
    );
    const evh_1040167445267876_submit_8809 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_8810,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8809],
      }
    );
    const act_1419464017721962_closeComponent_8814 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_8813 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_8814,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8813],
      }
    );
    return {
      act_7315092382398562_closeModal_8806,
      evh_7315092382398562_close_8805,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8808,
      evh_2248226175642056_close_8807,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_8812,
      evh_1040167445267876_success_8811,
      act_1040167445267876_request_8810,
      evh_1040167445267876_submit_8809,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_8814,
      evh_1419464017721962_clickPreventStop_8813,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_8810,
    }
  }
}

Vue.component("BulkContractServiceFeeEditor", BulkContractServiceFeeEditor);

</script>